import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'

import CategoriaGrid from './CategoriaGrid';
import CategoriaAbm from './CategoriaAbm';
import {FormattedMessage, injectIntl} from 'react-intl';

class Categorias extends Component {
	render() {
	    return (
			<div className="content-wrapper">
				<div className="content-header row">
					<div className="content-header-left col-md-6 col-12 mb-2">
      					<h3 className="content-header-title"><FormattedMessage id="categorias.categorias" defaultMessage="Categorías"/></h3>
      				</div>
				</div>
				<div className="content-body">
					<Switch>
						<Route exact path={`${this.props.match.url}`} component={CategoriaGrid} />
						<Route exact path={`${this.props.match.url}/add`} render={(props) => <CategoriaAbm {...props} action="ADD" />} />
						<Route exact path={`${this.props.match.url}/:id/edit`} render={(props) => <CategoriaAbm {...props} action="EDIT" />} />
                        <Route path={`${this.props.match.url}/:id`} render={(props) => <CategoriaAbm {...props} action="VIEW" />} />
					</Switch>										
				</div>
			</div>
	    );
  	}
}

export default injectIntl(Categorias);